export default "/938e5645029f01eb7fbf114944e485c2.jpg";